export const environment = {
    production: false,
  taf_base_url : "https://minoterie.sentech.tech/taf/"
};
